import { redirectToLogin } from '../../core/authentication';
import { PAGES_BASE_PATHNAMES } from '../../core/consts';
import { OktaGroups, OktaScopes, OktaScopesConfig } from '../../core/okta-auth-api.consts';
import { PageHeaderMenuItemConfig } from './page-header.types';

export const PageHeaderBaseMenuConfig: PageHeaderMenuItemConfig[] = [
  {
    title: 'API Documentation',
    url: null,
    needs_auth: true,
    sub_menu: [
      {
        title: OktaScopesConfig[OktaScopes.LiveFeed].title,
        url: `${PAGES_BASE_PATHNAMES.Catalog}/${OktaScopes.LiveFeed.toLocaleLowerCase()}`,
        needs_auth: true,
        needs_groups: [OktaGroups.LiveFeed],
      },
      {
        title: OktaScopesConfig[OktaScopes.WorkZones].title,
        url: `${PAGES_BASE_PATHNAMES.Catalog}/${OktaScopes.WorkZones.toLocaleLowerCase()}`,
        needs_auth: true,
        needs_groups: [OktaGroups.WorkZones],
      },
      {
        title: OktaScopesConfig[OktaScopes.RoadInventory].title,
        url: `${PAGES_BASE_PATHNAMES.Catalog}/${OktaScopes.RoadInventory.toLocaleLowerCase()}`,
        needs_auth: true,
        needs_groups: [OktaGroups.RoadInventory],
      },
      {
        title: OktaScopesConfig[OktaScopes.VirtualCamera].title,
        // badge: "Beta",
        url: `${PAGES_BASE_PATHNAMES.Catalog}/${OktaScopes.VirtualCamera.toLocaleLowerCase()}`,
        needs_auth: true,
        needs_groups: [OktaGroups.VirtualCam],
      },
    ],
  },
  { title: 'API Access', url: PAGES_BASE_PATHNAMES.Dashboard, needs_auth: true },
  {
    title: '',
    url: null,
    needs_auth: true,
    sub_menu: [
      {
        title: 'Sign out',
        url: null,
        method: () => {
          redirectToLogin(true);
        },
        needs_auth: true,
      },
    ],
  },
  {
    title: 'Sign in',
    url: null,
    method: () => {
      redirectToLogin(true);
    },
    needs_auth: false,
    hide_when_authenticated: true,
  },
  {
    title: 'Sign up',
    url: PAGES_BASE_PATHNAMES.SignUp,
    needs_auth: false,
    hide_when_authenticated: true,
    css_classes: ['btn', 'btn-primary'],
    non_staged_content: true,
  },
];
